<template>
  <div class="statistic-card-header">
    <span class="card-header__title">
      {{$t('feed.analytics.statistics.period')}}:
      <b>{{periodName}}</b>
    </span>
    <period-range :chart-name="chartName"/>
  </div>
</template>

<script>
// components
import PeriodRange from "../../../../../../../../components/periodRange/PeriodRange";

export default {
  name: "StatisticHeader",
  props: {
    chartName: {
      type: String
    }
  },
  computed: {
    periodName() {
      return this.$store.getters.periodName(this.chartName, this.$i18n);
    }
  },
  components: {
    PeriodRange
  }
};
</script>

<style>
@import "../../../../../../../../style/cardHeaderTitle.css";
.statistic-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
